<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <div mat-dialog-title class="matDialogTitle" cdkDragHandle>
        <mat-progress-bar mode="indeterminate" [hidden]="!loading" class="detaile"></mat-progress-bar>
        <span>
            <span>فاکتور خرید</span>
        </span>
        <span (click)="close()">
            <mat-icon class="close">close</mat-icon>
        </span>
    </div>
</div>

<form [formGroup]="form1_group" (ngSubmit)="check_access(type_task,1)">
    <div mat-dialog-content class="matDialogContent">
        <div class="row pe1">

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
                [hidden]="invoice_type_id > 0">
                <label for="status_id" class='wh-label'>
                    <span *ngIf="lang == 1"> نوع فاکتور : </span>
                    <span *ngIf="lang == 2"> Invoice Type : </span>
                    <span (click)="reset_input(196)">
                        <mat-icon class="close" class="input_search input_search_pe"
                            [ngClass]="{input_search_en:lang==2}">close</mat-icon>
                    </span>
                    <input class="wh-input" formControlName="invoice_type_title" (click)="load_services(196) "
                        [required]="required()" readonly>
                    <input class="wh-input" formControlName="invoice_type" [hidden]="true" [required]="required()"
                        readonly>
                </label>
            </div>


            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="title" class='wh-label'>
                    <span *ngIf="lang == 1"> شماره فاکتور : </span>
                    <span *ngIf="lang == 2"> Invoice Title : </span>
                    <input class='wh-input' formControlName="invoice_number" (keyup.enter)="check_access(type_task,1)"
                        autocomplete="off" [readonly]="readonly">
                </label>
            </div>


            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="issue_date" class="wh-label">
                    <span>تاریخ صدور /دریافت: </span>
                    <div style="width:100%">
                        <input class="wh-input" matInput [matDatepicker]="picker" formControlName="invoice_date"
                            [required]="required()" autocomplete="off" [readonly]="readonly"
                            (dateChange)="change_start_date()">
                        <mat-datepicker-toggle matSuffix [for]="picker" class="datepicker1"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </div>
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="status_id" class='wh-label'>
                    <span (click)="add_user()" [hidden]="readonly">
                        <i class="fas fa-bookmark cursor" style="float: left; font-size: 1rem;padding-bottom:2px"></i>
                    </span>
                    <span *ngIf="lang == 1"> نام تامین کننده : </span>
                    <span *ngIf="lang == 2"> User : </span>
                    <span (click)="reset_input(24)" [hidden]="readonly">
                        <mat-icon class="close" class="input_search input_search_pe"
                            [ngClass]="{input_search_en:lang==2}">close</mat-icon>
                    </span>
                    <input class="wh-input" formControlName="user_title" (click)="load_services(24) " readonly
                        [required]="required()" [readonly]="readonly">
                    <input class="wh-input" formControlName="user" [hidden]="true" readonly [required]="required()">
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="status_id" class='wh-label'>
                    <span *ngIf="lang == 1"> واحد پولی : </span>
                    <span *ngIf="lang == 2"> Currency : </span>
                    <span (click)="reset_input(216)" [hidden]="readonly">
                        <mat-icon class="close" class="input_search input_search_pe"
                            [ngClass]="{input_search_en:lang==2}">close</mat-icon>
                    </span>
                    <input class="wh-input" formControlName="currency_title" (click)="load_services(216) " readonly>
                    <input class="wh-input" formControlName="currency" [hidden]="true" readonly>
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="title" class='wh-label'>
                    <span *ngIf="lang == 1"> نرخ تبدیل : </span>
                    <span *ngIf="lang == 2"> Rate : </span>
                    <input class='wh-input' formControlName="rate" (keyup.enter)="check_access(type_task,1)"
                        autocomplete="off" [required]="required()" currencyMask [readonly]="readonly">
                </label>
            </div>



            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
                [hidden]="true">
                <label for="sort" class='wh-label'>
                    <span *ngIf="lang == 1"> ترتیب : </span>
                    <span *ngIf="lang == 2"> Sort : </span>
                    <input class='wh-input' formControlName="sort" (keyup.enter)="check_access(type_task,1)"
                        autocomplete="off" [readonly]="readonly">
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
                [hidden]="true">
                <label for="status_id" class='wh-label'>
                    <span *ngIf="lang == 1"> وضعیت نمایش : </span>
                    <span *ngIf="lang == 2"> Status : </span>
                    <span (click)="reset_input(26)">
                        <mat-icon class="close" class="input_search input_search_pe"
                            [ngClass]="{input_search_en:lang==2}">close</mat-icon>
                    </span>
                    <input class="wh-input" formControlName="status_title" (click)="load_services(26) "
                        [required]="required()" readonly>
                    <input class="wh-input" formControlName="status_id" [hidden]="true" [required]="required()"
                        readonly>
                </label>
            </div>
        </div>
        <!-- ********************************************************************************************************* -->
        <div class="row">
            <div style="text-align:right;padding:1rem 0">
                <button type="button" (click)='add_to_invoice()' class="invoice_button2" [hidden]="readonly">درج قطعه
                </button>
            </div>
            <div class="content-body1 control-content-body" [ngClass]="{content_body_en:lang==2}"
                style='overflow-x:auto;direction:rtl;'>
                <mat-table [dataSource]="dataSource" style='min-width:100%'
                    class='table-scroll mat_table_fa_without_scroll_bg pe1'
                    [ngClass]="{mat_table_en_without_scroll:lang==2,en1:lang == 2}"
                    [ngStyle]="{'direction': lang == 2 ? 'ltr' : 'rtl' }">
                    <ng-container matColumnDef="row">
                        <mat-header-cell *matHeaderCellDef style='max-width:40px'>
                            <span *ngIf="lang == 1">ردیف</span>
                            <span *ngIf="lang == 2">#</span>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let x;let i = index" style='max-width:40px'>{{ i + 1 }}</mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="cate">
                        <mat-header-cell *matHeaderCellDef style="max-width:130px">
                            <span *ngIf="lang == 1">دسته بندی</span>
                            <span *ngIf="lang == 2">Order Title</span>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let x;let i = index" (click)="open_order(i,2,x.wharehouse_order_id)"
                            style="max-width:130px">
                            {{ x.wharehouse_material_cate_title }}</mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="material">
                        <mat-header-cell *matHeaderCellDef style="min-width: 300px;">
                            <span *ngIf="lang == 1">نام کالا</span>
                            <span *ngIf="lang == 2">Order Title</span>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let x;let i = index" style="direction: rtl;" style="min-width: 300px;"
                            (click)="open_order(i,2,x.wharehouse_order_id)">
                            {{ x.wharehouse_material_title }}</mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="place">
                        <mat-header-cell *matHeaderCellDef style="min-width: 120px;">
                            <span *ngIf="lang == 1">نام انبار</span>
                            <span *ngIf="lang == 2">----</span>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let x;let i = index" style="direction: rtl;" style="min-width: 120px;"
                            (click)="open_order(i,2,x.wharehouse_order_id)">
                            {{ x.wharehouse_place_title }}</mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="title">
                        <mat-header-cell *matHeaderCellDef [hidden]="true">
                            <span *ngIf="lang == 1">مدل قطعه</span>
                            <span *ngIf="lang == 2">Order Title</span>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let x;let i = index" (click)="open_order(i,2,x.wharehouse_order_id)"
                            [hidden]="true">
                            {{ x.wharehouse_order_title }}</mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="number">
                        <mat-header-cell *matHeaderCellDef style="max-width:100px">
                            <span *ngIf="lang == 1">تعداد</span>
                            <span *ngIf="lang == 2">Order Title</span>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let x;let i = index" (click)="open_order(i,2,x.wharehouse_order_id)"
                            style="max-width:100px">
                            {{ x.wharehouse_order_number | number }}</mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="weight">
                        <mat-header-cell *matHeaderCellDef style="max-width:100px">
                            <span *ngIf="lang == 1">واحد</span>
                            <span *ngIf="lang == 2">----</span>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let x;let i = index" (click)="open_order(i,2,x.wharehouse_order_id)"
                            style="max-width:100px">
                            {{ x.wharehouse_weight_title }}</mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="price">
                        <mat-header-cell *matHeaderCellDef style="max-width:100px">
                            <span *ngIf="lang == 1">قیمت واحد</span>
                            <span *ngIf="lang == 2">Order Title</span>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let x;let i = index" (click)="open_order(i,2,x.wharehouse_order_id)"
                            style="max-width:100px">
                            {{ x.wharehouse_order_cost | number }}</mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="sum">
                        <mat-header-cell *matHeaderCellDef style="max-width:100px">
                            <span *ngIf="lang == 1">جمع</span>
                            <span *ngIf="lang == 2">Sum</span>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let x;let i = index" (click)="open_order(i,2,x.wharehouse_order_id)"
                            style="max-width:100px">
                            {{ x.sum | number}}</mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="operation">
                        <mat-header-cell *matHeaderCellDef style='max-width:100px' [hidden]="readonly">
                            <span *ngIf="lang == 1"> عملیات </span>
                            <span *ngIf="lang == 2">Operation</span>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let x;let i = index" style='max-width:100px' [hidden]="readonly">
                            <span (click)='open_order(i,2,x.wharehouse_order_id)'><i
                                    class="fas fa-desktop icon"></i></span>
                            <!-- x.wharehouse_order_material,x.wharehouse_order_status_add -->
                            <span (click)="check_to_delete(x.wharehouse_order_id,x.wharehouse_order_material)"><i
                                    class="far fa-trash-alt icon" style='margin:0px 4px;'></i></span>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row class="mat-header-row-dialog" *matHeaderRowDef="displayedColumns" color="primary">
                    </mat-header-row>
                    <mat-row class="mat-header-row-dialog" *matRowDef="let row;columns:displayedColumns;let i = index"
                        (click)="mat_table_selectedRow = row" (mouseenter)="mat_table_hoverRow = row"
                        [ngClass]="{'mat_table_selected': row === mat_table_selectedRow,mat_table_selected2:row.checked == true,'mat_table_hover': row === mat_table_hoverRow}"
                        class="cursor" [ngStyle]="{'backgroundColor':row.wharehouse_order_status_color}"></mat-row>

                </mat-table>
            </div>
            <div style="text-align: right;padding-top:1rem;">
                <span> جمع کل به عدد : {{ sum_all | number }} </span><span>{{ currency_title }}</span>
                <span> به حروف </span>
                <span> {{ sum_all_letter }} </span>
                <span> {{ currency_title }} </span>
            </div>
        </div><!-- row -->
        <!-- ********************************************************************************************************* -->
    </div><!-- content -->

    <div mat-dialog-actions class="matDialogActions">
        <div class="row" style="width: 100%;">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12" style="text-align: right;padding-right:0px">
                <button type="submit" [disabled]="!form1_group.valid || (list_order.length == 0 && this.i == -1)"
                    class="btn_pe" [ngClass]="{btn_en:lang == 2}" *ngIf="type_task == 1 || type_task == 2"
                    [hidden]="readonly">
                    <span *ngIf="lang == 2">Save</span>
                    <span *ngIf="lang == 1">ذخیره</span>
                </button>
                <button type="submit" class="btn_pe" [ngClass]="{btn_en:lang == 2}" *ngIf="type_task == 3">
                    <span *ngIf="lang == 2">Search</span>
                    <span *ngIf="lang == 1">جستجو</span>
                </button>
                <button type="button" class="btn_pe" [ngClass]="{btn_en:lang == 2}" *ngIf="type_task == 3"
                    (click)="check_access(type_task,2)">
                    <span *ngIf="lang == 2">Excel</span>
                    <span *ngIf="lang == 1">خروجی اکسل</span>
                </button>
            </div>



        </div><!-- row -->
    </div>
</form>